<template>
  <el-container class="w-full h-full p-0 m-0 bg-gray-50">
    <el-header class="bg-white shadow-lg">
      <div class="header-body flex justify-between">
        <div class="flex">
          <div class="flex items-center justify-center pr-6">
            <img src="../../assets/logo.png" class="logo" alt="logo">
          </div>
          <el-menu mode="horizontal" router class="home-menu" active-text-color="#ff4d4f">
            <el-menu-item index="/">首页</el-menu-item>
<!--            <el-menu-item index="/pages/web/latest">最近学习</el-menu-item>-->
<!--            <el-menu-item index="/pages/web/logger">更新日志</el-menu-item>-->
            <el-menu-item index="/pages/web/examination">考试</el-menu-item>
          </el-menu>
        </div>

          <User/>

      </div>
    </el-header>
    <el-main class="flex-row m-0 p-0">
      <el-scrollbar class="h-full">
        <div class="pt-6">
          <router-view></router-view>
          <el-footer class="text-center">
            <p class="text-sm text-gray-500">Copyright &copy; 2023 Hankun Company Inc.</p>
          </el-footer>
        </div>
      </el-scrollbar>
    </el-main>

  </el-container>
</template>
<script>
import User from "./components/User";

export default {
  name: "WebLayout",
  components: {
    User
  },
  /**
   * 组建属性
   * @type {Object}
   */
  props: {},
  /**
   * 数据字段
   * @return {[type]} [description]
   */
  data() {
    return {};
  },
  /**
   * 计算属性
   * @type {Object}
   */
  computed: {},
  /**
   * 数据监听
   * @type {Object}
   */
  watch: {},
  /**
   * 页面创建时
   * @return {[type]} [description]
   */
  created() {

  },
  /**
   * 页面加载时
   * @return {[type]} [description]
   */
  mounted() {

  },
  /**
   * 页面调用函数
   * @type {Object}
   */
  methods: {}
};
</script>
<style>
.header-body, .main-body {
  width: 1200px;
  margin: 0 auto;
}

.home-menu .el-menu-item {
  font-weight: bolder;
}

.score {
  background: darkorange;
  height: 30px;
  line-height: 30px;
  color: #fff;
  padding: 0 10px;
  border-radius: 15px;
  width: 80px;
  text-align: center;
}
</style>
